import React from 'react';
import { PageProps } from 'gatsby';

import type { PageContext as PageContextModel } from '@models';
import type { Context } from '@context/global';
import { initialPageState, type PageState } from '@context/pageState';
import PageReducer, { type PageStateActions } from '@context/pageReducer';

export type PageContext = Context<PageState, PageStateActions>;

export const PageStateContext = React.createContext<PageContext>([
    initialPageState,
    (value) => {},
]);

interface PageProviderProps {
    children: React.ReactElement<PageProps<any, PageContext>>;
    context: PageContextModel;
}

export const PageProvider = ({ children, context }: PageProviderProps) => {
    const state: PageState = {
        id: context.id,
        slug: context.slug,
        locale: context.locale,
        isLivePreview: false,
    };

    const reducerValue = React.useReducer(PageReducer, state);

    return (
        <PageStateContext.Provider value={ reducerValue }>
            { children }
        </PageStateContext.Provider>
    );
};

export const usePageState = (): PageContext => {
    const context = React.useContext(PageStateContext);
    if (!context) throw new Error('usePageState used outside of PageStateContext');

    return context;
}
